// extracted by mini-css-extract-plugin
module.exports = {"BrandLogo":"_2nht0bQIGy9gCW1s0IJGGr","img":"_3yOEoFvrV7bpvnXgVlHGzO","name":"_28pubgFi1NNHcIGDKW01bR"};